import React, { useEffect } from 'react';
import CheckoutShipping from '../Checkout/CheckoutShipping';
import CheckoutShippingMethod from '../Checkout/CheckoutShippingMethod';
import CheckoutPaymentMethod from '../Checkout/CheckoutPaymentMethod';
import CheckoutCartList from '../Checkout/CheckoutCartList';
import System from 'src/helper/system';
import ShowAlert from 'src/component/Global/ShowAlert';
import CheckoutTotal from '../Checkout/CheckoutTotal';
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Helper from 'src/helper/Helper';

export function Checkout() {
    const [{ system_alert_list }, { }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        Helper.feedBackButtonScript()
       }, []);
    return (
        <>
            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
            <div className='checkout-process pt-3'>
                <div className='container'>
                    <div className='bs5 row'>
                        <div className='col-12'>
                            <a href={void (0)} onClick={() => System.popup("ReturnToCartPopup")}
                                className="return-to-order d-inline-flex align-items-center w-auto mb-2">
                                <i className='return-cart me-1'></i><span>Return to Cart</span>
                            </a>
                            <div className='cart-alert'>
                                <ShowAlert doNotShow={['ExportCompliance']}/>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                            <div className='checkout-steps'>
                                <CheckoutShipping />

                                <CheckoutShippingMethod />

                                <CheckoutPaymentMethod />

                                <CheckoutCartList />

                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                            <CheckoutTotal isFrom="checkout" />
                        </div>
                    </div>

                </div>

            </div>
        </>
    )

}